import capitalize from './capitalize';

export default (value?: string) => {
    if (!value) return '';
    return value
        .replace(/\s+/g, ' ')
        .split(/\s/g)
        .map((i) =>
            i
                .split('-')
                .map((y) => capitalize(y))
                .join('-'),
        )
        .join(' ');
};
